import { formatDate, formatMonthList } from '@/components/BaseUi/Form/utils';

let list = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
const currentYear = formatDate(new Date()).split(' ')[0].split('-')[0].slice(2);

// 校验年份
export const checkYear = function (value) {
  if (value.length > 4) {
    const year = value.slice(3);
    if (year - currentYear < 0) {
      return true;
    } else if (year === currentYear) {
      list = formatMonthList();
      if (list.indexOf(value.slice(0, 2)) === -1) {
        return true;
      }
    } else {
      return false;
    }
  }
};
